var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on("click keyup", function (event) {
        if (event.type === "keyup") {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if (code !== 32 && code !== 13) {
                return false;
            }
        }
        handler.call(this, event);
    });
};

var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad() {
    // Add hcaptcha to all forms on a page
    jq(".h-captcha").each(function () {
        var form = jq(this).closest("form");
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            sitekey: window.hCaptchaSiteKey,
            callback: function (token) {
                jq("<input>", {
                    type: "hidden",
                    name: "h-captcha-response",
                    value: token,
                }).appendTo(form);
                form.submit();
            },
        });
    });
}

/**
 * Initializes validation for all forms with the "validate-form" class.
 * 
 * This function sets up custom validation rules, error handling, and submission logic
 * using the jQuery Validation plugin.
 */
function validate_forms() {
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr("id");
        jq(this).validate({
            errorElement: "span",
            errorClass: "error eq-error",
            rules: {
                password_confirm: {
                    equalTo: "#password"
                }
            },
            messages: {
                password_confirm: {
                    equalTo: "Passwords must be the same"
                }
            },
            errorPlacement: function (error, element) {
                var elementId = element.attr("id");
                var errorId = elementId + "-error";
                element.attr("aria-describedby", errorId);
                element.attr("aria-invalid", "true");

                if (element.attr("type") === "radio") {
                    error.prependTo(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            success: function (label) {
                // Remove the error message on successful validation
                var elementId = label.attr("id").replace('-error', '');
                var errorId = elementId + "-error";
                var inputElement = jq('#' + elementId);
                
                inputElement.removeAttr("aria-describedby");
                inputElement.removeAttr("aria-invalid");
                label.remove();
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form
            invalidHandler: function (event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: "instant", block: "center" });
                    errorElement.focus();
                }
            },
        });
    });

    // Custom email validation method
    jq.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    };
}

/**
 * Focus form messages for accessibility
 * Automatically focuses form message containers (success or error) when page loads
 * to ensure screen readers announce the message
 * 
 * Focuses the first visible child element (skips sr-only) to avoid JAWS page title reading issues
 */
function focusFormMessage() {
    // Helper function to find first child that's not sr-only
    function findFirstVisibleChild(container) {
        let child = container.firstElementChild;
        while (child) {
            // Skip elements with sr-only class
            if (!child.classList.contains('sr-only')) {
                return child;
            }
            child = child.nextElementSibling;
        }
        return null;
    }
    
    // Check for thank you messages (redirect pages)
    const thankYouMessage = document.getElementById('thank-you-message');
    if (thankYouMessage) {
        requestAnimationFrame(function() {
            const firstVisibleChild = findFirstVisibleChild(thankYouMessage);
            const elementToFocus = firstVisibleChild || thankYouMessage;
            
            if (!elementToFocus.hasAttribute('tabindex')) {
                elementToFocus.setAttribute('tabindex', '0');
            }
            
            elementToFocus.focus();
            elementToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return;
    }
    
    // Check for inline form messages (email alerts, etc.)
    const formMessage = document.getElementById('form-message');
    if (formMessage) {
        requestAnimationFrame(function() {
            const firstVisibleChild = findFirstVisibleChild(formMessage);
            const elementToFocus = firstVisibleChild || formMessage;
            
            if (!elementToFocus.hasAttribute('tabindex')) {
                elementToFocus.setAttribute('tabindex', '0');
            }
            
            elementToFocus.focus();
            elementToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
}

// Main document ready scripts
jq(document).ready(function () {
    // Basic Form Validation
    validate_forms();
    
    // Focus form messages for accessibility
    focusFormMessage();

    // Restore focus to filter control after filter-triggered reload (2.4.3 Focus Order)
    // Preserves linkable filtered states when opening a URL with focus= (e.g. shared link).
    (function () {
        var params = new URLSearchParams(window.location.search);
        var focusId = params.get("focus");
        if (focusId) {
            var el = document.getElementById(focusId);
            if (el && (el.tagName === "SELECT" || el.tagName === "INPUT" || el.getAttribute("role") === "combobox")) {
                requestAnimationFrame(function () {
                    el.focus();
                    el.scrollIntoView({ behavior: "smooth", block: "center" });
                });
                params.delete("focus");
                var newSearch = params.toString();
                var newUrl = window.location.pathname + (newSearch ? "?" + newSearch : "") + window.location.hash;
                if (window.history.replaceState) {
                    window.history.replaceState({}, "", newUrl);
                }
            }
        }
    })();

    // Pagination
    const paginationMobile = jq("#pagination--mobile");
    if (paginationMobile.length) {
        jq(this)
            .find("#pagination--mobile-select")
            .change(function () {
                var selectedPage = jq(this).val();
                location.href = encodeURI(selectedPage);
            });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr("rel");
        if (!linkRel || (linkRel && linkRel.indexOf("noopener") == -1)) {
            var newRel = linkRel === undefined ? "" : linkRel;
            newRel += linkRel && linkRel.length ? " noopener" : "noopener";
            jq(this).attr("rel", newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute("title") === null) {
            this.setAttribute("title", "Opens in a new window");
        }
    });
    addRequiredAsteriskToLabels();

    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    var mainContent = document.getElementById("mainContent");
    
    // If #mainContent doesn't exist, hide #scroll-more
    if (!mainContent && scrollMore) {
        scrollMore.style.display = "none";
    } else if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
    
            // Adjust scroll offset based on header height
            let header = document.querySelector("#site-header");
            var animationDistance =
                window.innerWidth <= 991 &&
                header &&
                window.getComputedStyle(header).getPropertyValue("position") !== "fixed"
                    ? 0
                    : jq("#site-header").outerHeight();
    
            // Smooth scroll to #mainContent
            jq("html, body").animate(
                {
                    scrollTop: jq(mainContent).offset().top - animationDistance,
                },
                "slow"
            );
        });
    }

    // Affix replacement - adds .affix class on scroll (replaces Bootstrap 3 affix plugin)
    var subNav = jq(".sub-navigation.affixed");
    if (subNav.length) {
        var subNavWrapper = subNav.closest(".sub-navigation-wrapper");
        var headerHeight = jq("#site-header").outerHeight() || 130;
        
        // Calculate the offset - when the sub-nav wrapper top reaches the header bottom
        var subNavOffsetTop = subNavWrapper.length ? subNavWrapper.offset().top : subNav.offset().top;
        var affixOffset = subNavOffsetTop - headerHeight;
        
        jq(window).on("scroll", function() {
            var scrollTop = jq(window).scrollTop();
            if (scrollTop >= affixOffset) {
                subNav.addClass("affix");
            } else {
                subNav.removeClass("affix");
            }
        });
        
        // Recalculate on resize
        jq(window).on("resize", function() {
            headerHeight = jq("#site-header").outerHeight() || 130;
            subNavOffsetTop = subNavWrapper.length ? subNavWrapper.offset().top : subNav.offset().top;
            affixOffset = subNavOffsetTop - headerHeight;
        });
        
        // Trigger once on load
        jq(window).trigger("scroll");
    }

    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if (divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                        svgElm = jq(this).find(".circle"),
                        percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({ percentage: 0 })
                        .stop(true)
                        .animate(
                            { percentage: percentNumber },
                            {
                                duration: 2000,
                                step: function () {
                                    var percentageVal = Math.round(this.percentage);
                                    percDiv.text(percentageVal + "%");
                                },
                            }
                        )
                        .promise()
                        .done(function () {
                            percDiv.text(percentNumber + "%");
                        });
                });
                jq(document).unbind("scroll");
            }
        });
    }

    var menuRight = document.getElementById("main-nav"),
        showRight = document.getElementById("showRight");

    function getMenuFromTrigger(trigger) {
        if (!trigger || !trigger.getAttribute) return { panel: menuRight, trigger: showRight };
        var panelId = trigger.getAttribute("aria-controls");
        return {
            panel: panelId ? document.getElementById(panelId) : menuRight,
            trigger: trigger
        };
    }

    function getOpenMenuPair() {
        var openPanel = document.querySelector(".cbp-spmenu.cbp-spmenu-open");
        if (!openPanel) return { panel: menuRight, trigger: showRight };
        var panelId = openPanel.id;
        var trigger = panelId ? document.querySelector("[aria-controls=\"" + panelId + "\"]") : showRight;
        return { panel: openPanel, trigger: trigger || showRight };
    }

    jq.fn.openMobileRightMenu = function (triggerEl) {
        var pair = triggerEl ? getMenuFromTrigger(triggerEl) : getOpenMenuPair();
        var activePanel = pair.panel;
        var activeTrigger = pair.trigger;
        toggleMenuKeybind(activePanel, activeTrigger);
        jq(activeTrigger).toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(activePanel).toggleClass("cbp-spmenu-open");
        if (activeTrigger !== showRight) {
            jq(showRight).toggleClass("disabled");
        }
        if (jq(activeTrigger).hasClass("active")) {
            jq(activeTrigger).attr("aria-label", "Close main navigation");
            jq(activeTrigger).attr("aria-expanded", "true");
        } else {
            jq(activeTrigger).attr("aria-label", "Expand main navigation");
            jq(activeTrigger).attr("aria-expanded", "false");
        }
    };

    // Disable menu toggle when a link is clicked
    jq(".main-menu a").on("click", function () {
        var openPanel = document.querySelector(".cbp-spmenu.cbp-spmenu-open");
        if (openPanel && jq(this).closest(".cbp-spmenu").length) {
            var trigger = document.querySelector("[aria-controls=\"" + openPanel.id + "\"]");
            if (trigger) {
                jq(trigger).removeClass("active");
                jq("body").removeClass("push-to-left");
                jq(openPanel).removeClass("cbp-spmenu-open");
            }
        }
    });

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }

    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    function toggleMenuKeybind(activePanel, activeTrigger) {
        activePanel = activePanel || menuRight;
        activeTrigger = activeTrigger || showRight;
        var $body = jq("body");
        if ($body.hasClass("push-to-left")) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(activeTrigger).toggleClass("active");
                    jq("body").toggleClass("push-to-left");
                    jq(activePanel).toggleClass("cbp-spmenu-open");
                    if (activeTrigger !== showRight) {
                        jq(showRight).removeClass("disabled");
                    }
                    $body.off("keydown");
                }
            });
        }
    }

    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e) {
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length - 1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // Filter updates via AJAX with linkable URLs (pushState). Preserves focus on the control that was changed (2.4.3 Focus Order).
    (function () {
        function fetchAndReplace(containerId, url, focusEl, shouldPushState) {
            var container = document.getElementById(containerId);
            if (!container) return;
            var focusName = focusEl ? focusEl.getAttribute("name") : null;
            fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
                .then(function (response) {
                    if (!response.ok) { throw new Error("Network response was not ok"); }
                    return response.text();
                })
                .then(function (html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
                    var newContent = doc.getElementById(containerId);
                    if (newContent) {
                        container.innerHTML = newContent.innerHTML;
                        if (shouldPushState !== false && window.history.pushState) {
                            window.history.pushState({ filterContainer: containerId }, "", url);
                        }
                        var restoredFocus = focusName
                            ? container.querySelector("[name=\"" + focusName + "\"]")
                            : null;
                        if (restoredFocus && (restoredFocus.tagName === "SELECT" || restoredFocus.tagName === "INPUT" || restoredFocus.getAttribute("role") === "combobox")) {
                            requestAnimationFrame(function () {
                                restoredFocus.focus();
                                restoredFocus.scrollIntoView({ behavior: "smooth", block: "center" });
                            });
                        }
                    } else {
                        window.location.href = url;
                    }
                })
                .catch(function () {
                    window.location.href = url;
                });
        }

        function setSelectsFromParams(params) {
            jq(".row-filter .eq-select").each(function () {
                var name = jq(this).attr("name");
                var val = params.get(name);
                if (name === "year") {
                    jq(this).val(val != null && val !== "" ? val : "-1");
                } else if (name === "category") {
                    jq(this).val(val != null ? val : "all");
                } else if (val != null) {
                    jq(this).val(val);
                }
            });
            jq("#sec-filing-filter select").each(function () {
                var name = jq(this).attr("name");
                var val = params.get(name);
                jq(this).val(val != null ? val : "");
            });
        }

        function syncUrlToFilterState() {
            var params = new URLSearchParams(window.location.search);
            var results = document.getElementById("row-filter-results");
            if (results) {
                setSelectsFromParams(params);
                var base = window.location.origin + window.location.pathname;
                var rowQs = params.toString();
                fetchAndReplace("row-filter-results", base + (rowQs ? "?" + rowQs : ""), null, false);
                return;
            }
            var secResults = document.getElementById("sec-filing-results");
            if (secResults) {
                var form = document.getElementById("sec-filing-filter");
                if (form) {
                    setSelectsFromParams(params);
                    var formUrl = form.action || window.location.href.split("?")[0];
                    var secQs = params.toString();
                    fetchAndReplace("sec-filing-results", formUrl + (secQs ? "?" + secQs : ""), null, false);
                }
            }
        }

        // SEC Filing Filters - AJAX update with linkable URL
        jq(document).on("change", "#sec-filing-filter select", function (e) {
            e.preventDefault();
            var form = jq(this).closest("form");
            var formUrl = form.attr("action") || (window.location.origin + window.location.pathname);
            var params = new URLSearchParams(new FormData(form[0]));
            if (jq(this).attr("name") === "cik") {
                params.delete("form_type");
                params.delete("year");
                params.delete("page");
            }
            var qs = params.toString();
            var url = formUrl + (qs ? "?" + qs : "");
            var focusEl = this;
            fetchAndReplace("sec-filing-results", url, focusEl);
        });

        // Row-filter (IR News / Press Releases) - AJAX update with linkable URL
        var $filterSelect = jq(".row-filter .eq-select");
        if ($filterSelect.length) {
            $filterSelect.on("change", function () {
                var base = window.location.origin + window.location.pathname;
                var query = "";
                jq(".row-filter .eq-select").each(function () {
                    var val = jq(this).val();
                    if (val != null && val !== "" && val !== "-1") {
                        query += (query ? "&" : "?") + encodeURIComponent(jq(this).attr("name")) + "=" + encodeURIComponent(val);
                    }
                });
                var url = base + query;
                var focusEl = this;
                fetchAndReplace("row-filter-results", url, focusEl);
            });
        }

        // Back/forward: restore content for current URL so linkable filter state works
        jq(window).on("popstate", function (e) {
            var state = e.originalEvent.state;
            if ((state && state.filterContainer) || (!state && window.location.search)) {
                syncUrlToFilterState();
            }
        });
    })();

    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
        jq(this).next(".spr-expandable").toggle("blind");
        jq(this).toggleClass("expanded");
        if (jq(this).hasClass("expanded")) {
            jq(this).attr("aria-pressed", true);
        } else {
            jq(this).attr("aria-pressed", false);
        }
    });

    // Crisis Messaging
    var $majorAnnouncement = jq("#majorAnnouncement");
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            let announcements = new EqDialog({
                show_close_button: true,
                remove_inline_content: true,
            });
            announcements.open("inline", "majorAnnouncement");
            let majorAnnouncementDialog = document.querySelector("dialog[open]");
            if (majorAnnouncementDialog && document.getElementById("major-announcement-title")) {
                majorAnnouncementDialog.setAttribute("aria-labelledby", "major-announcement-title");
                majorAnnouncementDialog.removeAttribute("aria-label");
            }
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }

    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    }

    function resize_events() {
        // Fix accessibility issue for main navigation and sub navigation triggers on mobile
        if (window.innerWidth <= 991) {
            jq(".mobile-nav-trigger").attr("tabindex", 0);
            jq(".mobile-sub-nav-trigger").attr("tabindex", 0);
            jq(".has-children ul li a").attr("tabindex", "-1");
            jq(".cbp-spmenu > .main-menu ul").attr("aria-hidden", "true");
            jq(".has-children ul").attr("aria-hidden", "true");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "true");
            if (jq(".cbp-spmenu").hasClass("cbp-spmenu-open")) {
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
            } else {
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", -1);
            }
        } else {
            jq(".mobile-nav-trigger").attr("tabindex", "");
            jq(".mobile-sub-nav-trigger").attr("tabindex", "");
            jq(".has-children ul li a").attr("tabindex", "");
            jq(".has-children ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
        }
    }
 
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function (evt) {
        resize_events();
    });

    // Enable accessible clicking on mobile navs and subnavs (supports integrated-site mobile header)
    jq(".mobile-nav-trigger").on("click", function (evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu(this);
        resize_events();
        return false;
    });
    // Close mobile nav when selecting the darkened body background
    jq(".cbp-spmenu").accessibleClick(function (evt) {
        evt.stopPropagation();
    });
    jq("body").on("click", function (evt) {
        if (this.classList.contains("push-to-left")) {
            jq(this).openMobileRightMenu(); /* no arg: close whichever menu is open */
            resize_events();
            return false;
        }
    });

    // Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function () {
        windowW = window.innerWidth;
    });

    // Close mobile nav after selecting anchor link, make selected link use active class
    jq(".main-menu > .has-children > a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        // Remove any existing active classes
        if (this.parentElement.classList.contains("active")) {
            this.parentElement.classList.remove("active");
            return;
        }
        jq(".main-menu > .has-children").each(function () {
            this.classList.remove("active");
        });
        this.parentElement.classList.add("active");
    });

    jq("#main-nav ul a, #mobile-nav-integrated ul a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        var panel = jq(this).closest(".cbp-spmenu").get(0);
        var trigger = panel && panel.id ? document.querySelector("[aria-controls=\"" + panel.id + "\"]") : null;
        if (panel) jq(panel).removeClass("cbp-spmenu-open");
        jq("body").removeClass("push-to-left");
        if (trigger) jq(trigger).removeClass("active");
    });


    //Accessible click for Financial Results collapse elements
    jq(".quarterly-results [role=button]").accessibleClick(function (evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != "click") {
            jq(this).click();
            return false;
        }
    });

    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");

    FinancialResultsExpandBtn.on("click", function (e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == "Expand All") {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });

    QuarterHeaders.on("click", function (e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });

    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on("click", function (e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger("click");
    });

    // Chart Library Functionality
    jq(".chart-table-expander").on("click", function (e) {
        e.target.classList.toggle("hidden");
        e.target.parentElement.querySelector(".chart-legend").classList.toggle("hidden");
    });

    // Remove width from table headers with only a superscript
    jq(".report .th").each(function () {
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();

        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                width: "0%",
                "padding-left": "0",
            });
        }
    });

    /**
     * Accessibility Fix for Radio Inputs
     **/
    let radioLabels = document.querySelectorAll(".eq-radio label");

    radioLabels.forEach(function (radioLabel) {
        radioLabel.setAttribute("tabindex", "0"); // Ensure labels are focusable

        radioLabel.addEventListener("keydown", function (e) {
            // Check if the key pressed is the spacebar
            if (e.key === " " || e.keyCode === 32) {
                e.preventDefault();
                let associatedRadio = document.getElementById(this.getAttribute("for"));
                // Check if the associated radio button exists and is not already checked
                if (associatedRadio && !associatedRadio.checked) {
                    associatedRadio.checked = true;
                    associatedRadio.dispatchEvent(new Event("change"));
                }
            }
        });
    });
    // MOBILE MENU TRAP FOCUS
    let lastNavItem = jq(".main-menu > li:last-child > a");
    let mobileTrigger = jq(".mobile-nav-trigger");
    // Normal Tab
    lastNavItem.on("keydown", function (e) {
        if (!e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            mobileTrigger.focus();
        }
    });
    // Shift + Tab
    mobileTrigger.on("keydown", function (e) {
        if (e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            lastNavItem.focus();
        }
    });
    //CCPA Request Form
    jq('#ccpa-request-form input[name="claim"]').change(function () {
        let value = jq(this).val();
        if (value == "Resident") {
            jq(".show-resident").removeClass("hide");
            jq(".show-representative").addClass("hide");
            jq("#certify_resident").addClass("required");
            jq("#certify_resident").attr("aria-required", "true");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("required");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("error");
            jq(".show-representative .conditional-required, #certify_representative").removeAttr("aria-required");
        } else if (value == "Representative") {
            jq(".show-representative").removeClass("hide");
            jq(".show-resident").addClass("hide");
            jq("#certify_resident").removeClass("required");
            jq("#certify_resident").removeClass("error");
            jq("#certify_resident").removeAttr("aria-required");
            jq(".show-representative .conditional-required, #certify_representative").addClass("required");
            jq(".show-representative .conditional-required, #certify_representative").attr("aria-required", "true");
        }
    });

    //Check for multiple forms and update ids to avoid duplicates
    let forms = jq("form");
    if (forms.length > 1) {
        const idCounts = {};
        forms.each(function (formIndex, form) {
            // Find all input elements within the form
            jq(form)
                .find("input")
                .each(function (inputIndex, input) {
                    const currentId = jq(input).attr("id");
                    if (currentId) {
                        // Generate a unique ID if there is a duplicate
                        if (!idCounts[currentId]) {
                            idCounts[currentId] = 0;
                        }
                        idCounts[currentId]++;
                        const uniqueId = `${currentId}_${formIndex}`;

                        // Update the input's id attribute to be unique
                        jq(input).attr("id", uniqueId);

                        // Update the corresponding label's for attribute
                        jq(form).find(`label[for="${currentId}"]`).attr("for", uniqueId);
                    }
                });
        });
    }

    jq(".collapse").on("shown.bs.collapse", function (event) {
        // Get the content element within the collapsed section
        let contentElement = jq(this).find(".text")[0];

        if (contentElement) {
            // Check if the content is not in the viewport before scrolling
            if (!isElementInViewport(contentElement)) {
                // Scroll to reveal the content
                contentElement.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                });
            }
        }
    });

    // Initialize dialogs
    let eq_dialogs = new EqDialog();
    eq_dialogs.init();
    
    //email alerts button eventlistener
    // Note: In Bootstrap 5, aria-expanded is updated BEFORE click handlers run,
    // so we check for 'true' (meaning it just opened)
    document.querySelector('.btn[href="#email-alerts-cta-form"]')?.addEventListener('click', function() {
        if (this.getAttribute('aria-expanded') === 'true') {
            const header = document.getElementById('header');
            const navHeight = (header ? header.offsetHeight : 0) + 20;
            const buttonTop = this.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: buttonTop - navHeight,
              behavior: 'smooth'
            });
        }
    });
    
}); // end document.ready

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required")
        .siblings("label")
        .each(function () {
            let currentText = jq(this).text();
            jq(this).text(currentText + "*");
        });
}

/**
 * addCustomErrorFormHandlers
 *
 * Sets up custom error handling for forms, specifically targeting required
 * checkboxes and radio button groups. Displays error messages and applies
 * border styling to elements that fail validation. Enhances accessibility by
 * updating ARIA attributes based on user interactions.
 *
 * - Applies different border colors for elements within dark-themed sections.
 * - Adds or removes error messages and styles based on validation results.
 * - Updates ARIA attributes for better accessibility.
 */

function addCustomErrorFormHandlers() {
    const BORDER_COLOR_LIGHT = "#D40033";
    const BORDER_COLOR_DARK = "#FA003A";

    // Listen for form submission
    jq("form").on("submit", function (e) {
        jq("ul.checkboxes.required, ul.radios.required").each(function () {
            let type = jq(this).hasClass("checkboxes") ? "checkbox" : "radio";
            let borderColor = jq(this).closest(".dark").length > 0 ? BORDER_COLOR_DARK : BORDER_COLOR_LIGHT;

            // Check if any input of the correct type in this group is checked
            if (jq(this).find('input[type="' + type + '"]:checked').length === 0) {
                jq(this).css("border", "1px solid " + borderColor);

                // Link error to checkbox/radio group
                let errorId = jq(this).parent().attr("aria-labelledby") + "-error";
                jq(this).parent().attr("aria-describedby", errorId);

                // Add error message if it does not already exist
                if (jq(this).siblings(".eq-error").length === 0) {
                    jq(this).after(`<span class="eq-error" id="${errorId}">This field is required</span>`);
                }
            } else {
                // Remove the border and error message if any input is checked
                jq(this).css("border", "");
                jq(this).siblings(".eq-error").remove();
                jq(this).parent().removeAttr("aria-describedby");
            }
        });
    });

    // Event handler for changes to checkboxes and radio buttons in all groups
    jq(document).on("change", 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function () {
        let ul = jq(this).closest("ul.checkboxes, ul.radios");

        // Update ARIA attributes for accessibility
        if (jq(this).attr("type") === "radio") {
            // Set aria-checked for all radio buttons in the group
            ul.find('input[type="radio"]').attr("aria-checked", "false");
            jq(this).attr("aria-checked", "true");
        } else {
            jq(this).attr("aria-checked", this.checked);
        }

        // Check if any input in this group is checked
        if (ul.find("input:checked").length > 0) {
            // If an input is checked, remove the border and error message
            ul.css("border", "");
            ul.siblings(".eq-error").remove();
        }
    });

    // Initialize ARIA attributes on page load
    jq('ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]').each(function () {
        jq(this).attr("aria-checked", this.checked);
    });
}

// Call the function to setup event handlers once the document is ready
jq(document).ready(function () {
    addCustomErrorFormHandlers();
});

//SMOOTH SCROLL
// Scrolling when accesing an URL with a hash in there
let windowLocationHash = window.location.hash;
if (windowLocationHash.length) {
    let hashElement = jq(windowLocationHash);
    if (hashElement.length) {
        let offset = 0;
        let header = jq("#site-header");
        let subNav = jq(".sub-navigation");
        if (header.length) {
            offset += header.outerHeight();
        }
        if (subNav.length) {
            offset += subNav.outerHeight();
        }
        jq("html,body").animate(
            {
                scrollTop: hashElement.offset().top - offset,
            },
            300
        );
    }
}
// Smooth scroll animation when a link containing # in the href is clicked
jq('a[href*="#"]').on("click", function (event) {
    // Check for any anchor links we want to ignore
    if (jq(this).hasClass("chart-legend-trigger") || jq(this).hasClass("accordion-btn") || jq(this).hasClass("eq-dialog") || jq(this).closest(".tab-header").length) {
        return; // Exit the function early if ignored links are found
    }

    // Check if the href contains #
    if (this.hash !== "") {
        // Prevent default anchor click behavior for regular anchor links
        // Only prevent default anchor behavior if it is targeting the current page
        if (this.href == window.location.href) {
            event.preventDefault();
        }

        // Store hash
        let hash = this.hash;
        let id = hash.split("#")[1];

        // Call the named function smoothScrollToHash for regular anchor links
        // If the target is a collapsed box, wait for it to open
        let el = document.getElementById(id);
        if (el && el.classList.contains("panel-collapse")) {
            setTimeout(() => {
                smoothScrollToHash(hash);
            }, 100);
        } else {
            smoothScrollToHash(hash);
        }
    }
});
function smoothScrollToHash(hash) {
    if (hash.length) {
        let hashElement = jq(hash);
        if (hashElement.length) {
            let offset = 0;
            let header = jq("#site-header");
            let subNav = jq(".sub-navigation");
            if (header.length) {
                offset += header.outerHeight();
            }
            if (subNav.length) {
                offset += subNav.outerHeight();
            }
            jq("html,body").animate(
                {
                    scrollTop: hashElement.offset().top - offset,
                },
                800
            );
        }
    }
}

//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-bs-toggle='collapse']") {
    if (jq(selector + ".collapsed").length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text("Expand All");
    } else {
        btn.text("Collapse All");
    }
}

// Checkbox Groups - SEC Filings: parent "All SEC Filings" and child checkboxes
// Parent when checked: check all children but do NOT disable them (accessibility: users can see/change child state).
// Parent is never auto-checked when user manually checks all four children; aria-checked="mixed" reflects partial/full child selection.

function updateSecParentAriaChecked(parentCheckbox) {
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");
    const checkedCount = childCheckboxes.filter(":checked").length;
    const total = childCheckboxes.length;
    if (parentCheckbox.is(":checked")) {
        parentCheckbox.attr("aria-checked", "true");
    } else if (checkedCount === 0) {
        parentCheckbox.attr("aria-checked", "false");
    } else {
        parentCheckbox.attr("aria-checked", "mixed");
    }
}

function initSecFilingsAriaChecked() {
    jq('[id^=ir-sec-all]').each(function () {
        const parentCheckbox = jq(this);
        const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");
        // Ensure children are never disabled so users can always see/change child state (accessibility)
        childCheckboxes.prop("disabled", false);
        updateSecParentAriaChecked(parentCheckbox);
    });
}

jq('[id^=ir-sec-all]').change(function () {
    const parentCheckbox = jq(this);
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");

    if (parentCheckbox.is(":checked")) {
        // Check all children; do not disable so users can see and change child state (accessibility)
        childCheckboxes
            .prop("checked", true)
            .prop("disabled", false)
            .attr("aria-checked", "true");
    } else {
        childCheckboxes
            .prop("checked", false)
            .prop("disabled", false)
            .attr("aria-checked", "false");
    }
    updateSecParentAriaChecked(parentCheckbox);
});

// Uncheck parent when any child is unchecked (saving must reflect actual selection - no regression).
// Do NOT auto-check parent when all four children are manually checked; use aria-checked="mixed" when some or all children selected.
jq(".ir-sec-sub").change(function () {
    const parentCheckbox = jq(this).closest("ul").parent().find("input[id^=ir-sec-all]");

    if (!jq(this).is(":checked")) {
        parentCheckbox.prop("checked", false);
    }
    updateSecParentAriaChecked(parentCheckbox);
});

jq(document).ready(function () {
    initSecFilingsAriaChecked();
});

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                var point = jq(this).find(".point");
                jq(this).css("height", point.outerHeight() / 1.2);
            });
        },
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    } else {
        jq("body").removeClass("scrollbar");
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate(
            {
                scrollTop: target.offset().top - jq("#site-header").height(),
            },
            "slow"
        );
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 *
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".report")) {
        // Find the table with class 'report'
        const reportTable = document.querySelector(".report");

        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll("td a");

            // Transform each <a> into a <span>
            tdWithLinks.forEach((aElement) => {
                const span = document.createElement("span");
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});

// Accesibility Form
let formCounter = 0;
jq(".add-request").accessibleClick(function () {
    formCounter++;
    let newFields = '<div class="info-block">' + '<div class="form-group">' + '<label for="url-' + formCounter + '">URL of requested document or webpage:</label>' + '<input type="text" name="url-' + formCounter + '" id="url-' + formCounter + '" value="" class="required form-control" placeholder="ex. https://www.website.com/page" />' + "</div>" + '<div class="form-group">' + '<label for="description-' + formCounter + '">Description of request or issue related to URL:</label>' + '<textarea name="description-' + formCounter + '" id="description-' + formCounter + '" value="" class="required form-control" placeholder="Enter a description of your request or issue related to the URL inputted above"></textarea>' + "</div>" + "</div>";
    jq(".request-info").append(newFields);
    jq("#url-" + formCounter).focus();
});

/**
 * Global - Decorative Image Alt Check
 *
 * This will check all images across the site to see if the image has a
 * empty or missing alt attribute. If so, aria-hidden="true" will be set.
 */
jq("img").each((ind, el) => {
    // Check if the image has empty or no alt attribute
    if (!jq(el).attr("alt") || jq(el).attr("alt").trim() === "") {
        // If the alt text is empty or not present, set aria-hidden="true"
        jq(el).attr("aria-hidden", "true");
    }
});

/**
 * Row Scripts
 *
 * These are specific to rows in template
 */

// Row News Financial Results Event
jq(document).ready(function () {
    // Scroll more home hero button
    let scrollMore = document.getElementById("scroll-more-midtown");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            let target = jq("#scroll-more-anchor");
            jq("html,body").animate(
                {
                    scrollTop: target.offset().top - jq("#site-header").height(),
                },
                "slow"
            );
        });
    }
});

/**
 * Footnotes Functionality
 */
const createSuperscriptLink = (id) => `<a href="#footnoteDesc${id}" aria-describedby="footnoteDesc${id}" tabindex="0" data-footnote="${id}" class="span-asterisk"><sup>*</sup></a>`;
let footnoteCounter = 0;
function processFootnotesInSection(stats, footnotes) {
    // Processing of footnotes
    footnotes.forEach((footnote) => {
        if (footnote.textContent.trim().startsWith("*")) {
            footnote.outerHTML = `<p id="footnoteDesc${++footnoteCounter}" class="footnote-desc" aria-label="Footnote ${footnoteCounter}" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        }
    });
    // Link asterisks in stats to footnotes
    stats.forEach((stat) => {
        let localCounter = footnoteCounter - 1;
        stat.innerHTML = stat.innerHTML.replace(/\*/g, () => createSuperscriptLink(++localCounter));
    });
}
function processAllFootnotes() {
    const sections = document.querySelectorAll(".container");
    sections.forEach((section) => {
        const stats = section.querySelectorAll(".stat p, .stat-box p");
        const footnotes = section.querySelectorAll(".financial-disclaimer .financial-text p, .source p");
        processFootnotesInSection(stats, footnotes);
    });
}

document.addEventListener('DOMContentLoaded', processAllFootnotes);

/**
 * Adjusts the scroll position to ensure the focused element is visible within the viewport.
 *
 * The function checks if the element is above the visible area or below the viewport,
 * and if so, it adjusts the scroll position to bring the element into view with extra space.
 */
function adjustScrollPosition(e) {
    const headerHeight = document.querySelector("#site-header").offsetHeight;
    const extraSpace = 80;
    const totalHeight = headerHeight + extraSpace;
    const elementTop = e.target.getBoundingClientRect().top;
    const elementBottom = e.target.getBoundingClientRect().bottom;

    let is_affixed = jq(e.target).closest(".affixed").length;

    if (!is_affixed && (elementTop < totalHeight || elementBottom > window.innerHeight)) {
        window.scrollTo({
            top: elementTop + window.scrollY - totalHeight,
            behavior: "smooth",
        });
    }
}

document.addEventListener("keydown", (e) => {
    if (e.key === "Tab" && e.shiftKey) {
        document.addEventListener("focusin", adjustScrollPosition);
    } else {
        document.removeEventListener("focusin", adjustScrollPosition);
    }
});

/**
 * Dynamically wrap tables inside news articles utilizing the Table Wrapper library
 */
document.querySelectorAll(".full-news-article table, .financials table").forEach((table, index) => {
  // Create the parent wrapper
  const parentWrapper = document.createElement("div");
  parentWrapper.className = "tw-parent";
  parentWrapper.setAttribute("data-aria-label", `Table ${index + 1}`);

  // Wrap the table inside the parent wrapper
  table.parentNode.insertBefore(parentWrapper, table);
  parentWrapper.appendChild(table);
});

/**
 * Enables keyboard navigation for tabs within a .tab-header element.
 *
 * Key Features:
 * - Navigation wraps around when reaching the first or last tab.
 * - Focus is moved to the new tab, and the `click` event is triggered to activate it.
 * - Prevents default behavior for smoother keyboard interactions.
 */
document.addEventListener('keydown', (event) => {
    // Check if the focus is inside a .tab-header element
    const activeTab = document.activeElement.closest('.tab-header .nav-link');
    if (!activeTab) return;

    const tabHeader = activeTab.closest('.tab-header');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    const currentIndex = tabs.indexOf(activeTab);

    let newIndex = -1;

    if (event.key === 'ArrowRight') {
        // Move to the next tab
        newIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
        // Move to the previous tab
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    }

    if (newIndex >= 0) {
        event.preventDefault();
        // Activate the new tab
        const newTab = tabs[newIndex];
        newTab.focus();
        newTab.click();
    }
});

/**
 * Enables keyboard activation of CTA Email Alert buttons.
 *
 * It should work with both space and enter keys
 */
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a.email-alerts-btn');
  links.forEach(function (link) {
    link.addEventListener('keydown', function (event) {
      if (event.key === ' ' || event.key === 'Spacebar') { // Spacebar for older browsers
        event.preventDefault(); // Prevent page scroll
        link.click();
      }
    });
  });
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// This replaces the jquery-match-height that has a CSP unsafe-inline conflict
// Collect elements into groups based on data-mh attribute
// using style property directly is compliant with CSP style-src directive
function updateMatchedHeights() {
    const groups = {};
    if (document.querySelectorAll('[data-mh]').length < 1) {
        return;
    }
    // Collect elements into groups based on data-mh attribute
    document.querySelectorAll('[data-mh]').forEach(el => {
        const groupName = el.getAttribute('data-mh');

        if (!groups[groupName]) {
            groups[groupName] = [];
        }

        groups[groupName].push(el);
    });

    // Reset heights before recalculating
    Object.values(groups).forEach(group => {
        group.forEach(el => el.style.height = 'auto');
    });

    // Find the tallest element in each group and apply that height to all members
    Object.values(groups).forEach(group => {
        const maxHeight = Math.max(...group.map(el => el.offsetHeight));
        group.forEach(el => el.style.height = `${maxHeight}px`);
    });
}

jq(window).on('load resize', updateMatchedHeights);

// This replaces the pipeline inline styles on the page that has conflicts with the CSP
// using style property directly is compliant with CSP style-src directive
function updatePipelineStyles() {
    if (document.querySelector('.pipeline-module')) {
        const pipelineModules = document.querySelectorAll('.pipeline-module');
        pipelineModules.forEach(module => {
            const statuses = module.querySelectorAll('.status');
            statuses.forEach(status => {
                const width = status.getAttribute('data-width');
                if (width) {
                    status.style.width = `${width}%`;
                }
            });
        });
    }
}

jq(window).on('load', updatePipelineStyles);

/**
 * Enhanced Tab Navigation for Row-Tabs Component
 * 
 * This script provides comprehensive keyboard navigation for tab components:
 * - Tab key navigation within tab panels
 * - Automatic progression to next tab when current panel content is exhausted
 * - Proper focus management and accessibility
 */

// Enhanced Tab Navigation Functions
function initTabNavigation() {
    // Find all tab containers
    const tabContainers = document.querySelectorAll('.tabs-box');
    
    tabContainers.forEach(function(container) {
        setupTabNavigation(container);
    });
}

function setupTabNavigation(container) {
    const tabHeader = container.querySelector('.tab-header');
    const tabContent = container.querySelector('.tab-content');
    
    if (!tabHeader || !tabContent) return;

    const tabList = tabHeader.querySelector('[role="tablist"]');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    const tabPanels = Array.from(tabContent.querySelectorAll('.tab-pane'));
    
    container._tabs = tabs;
    container._tabPanels = tabPanels;
    
    const activeTab = tabHeader.querySelector('.nav-link.active');
    container._currentTabIndex = activeTab ? tabs.indexOf(activeTab) : 0;

    if (tabList && !tabList.hasAttribute('aria-labelledby') && !tabList.hasAttribute('aria-label')) {
        const moduleContainer = container.closest('.container');
        const sectionHeading = moduleContainer ? moduleContainer.querySelector('.module-content h2, .module-content h3') : null;
        if (sectionHeading) {
            if (!sectionHeading.id) {
                sectionHeading.id = 'tablist-label-' + Math.random().toString(36).slice(2, 9);
            }
            tabList.setAttribute('aria-labelledby', sectionHeading.id);
        }
    }

    tabs.forEach(function(tab, index) {
        if (!tab.id) {
            const panelId = tab.getAttribute('aria-controls');
            tab.id = panelId ? 'btn-' + panelId : 'tab-btn-' + index;
        }
        const panel = tabPanels[index];
        if (panel && !panel.hasAttribute('aria-labelledby')) {
            panel.setAttribute('aria-labelledby', tab.id);
        }
    });

    tabPanels.forEach(function(panel) {
        panel.setAttribute('tabindex', '0');
    });

    tabs.forEach(function(tab) {
        tab.setAttribute('tabindex', '-1');
    });
    const initialActive = tabHeader.querySelector('.nav-link.active') || tabs[0];
    if (initialActive) {
        initialActive.setAttribute('tabindex', '0');
    }

    container.addEventListener('keydown', function(event) {
        handleTabNavigation(event, container);
    });

    tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
            container._currentTabIndex = index;
            tabs.forEach(function(t) { t.setAttribute('tabindex', '-1'); });
            tab.setAttribute('tabindex', '0');
        });
    });
}

function handleTabNavigation(event, container) {
    if (event.key !== 'Tab') return;

    const tabs = container._tabs;
    const tabPanels = container._tabPanels;

    if (!tabs || !tabPanels) return;

    const activeElement = document.activeElement;

    const currentPanel = Array.from(tabPanels).find(panel => panel.contains(activeElement));
    if (!currentPanel) return;

    const currentTabIndex = tabPanels.indexOf(currentPanel);
    if (currentTabIndex === -1) return;

    const isPanelFocused = activeElement === currentPanel;
    const focusableElements = getFocusableElementsInTab(currentPanel);
    const currentFocusIndex = isPanelFocused ? -1 : focusableElements.indexOf(activeElement);

    if (!event.shiftKey) {
        if (isPanelFocused) {
            if (focusableElements.length === 0 && currentTabIndex < tabs.length - 1) {
                event.preventDefault();
                switchToTabEnhanced(container, currentTabIndex + 1);
            }
        } else if (currentFocusIndex === focusableElements.length - 1) {
            if (currentTabIndex < tabs.length - 1) {
                event.preventDefault();
                switchToTabEnhanced(container, currentTabIndex + 1);
            }
        }
    } else {
        if (isPanelFocused || currentFocusIndex === 0) {
            event.preventDefault();
            tabs[currentTabIndex].focus();
        }
    }
}

function switchToTabEnhanced(container, tabIndex, focusTab = true) {
    const tabs = container._tabs;
    const tabPanels = container._tabPanels;
    
    if (!tabs || !tabPanels || tabIndex < 0 || tabIndex >= tabs.length) return;

    container._currentTabIndex = tabIndex;

    tabs.forEach(function(tab) {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
    });
    
    tabPanels.forEach(function(panel) {
        panel.classList.remove('show', 'active');
    });

    const newTab = tabs[tabIndex];
    const newPanel = tabPanels[tabIndex];
    
    newTab.classList.add('active');
    newTab.setAttribute('aria-selected', 'true');
    newTab.setAttribute('tabindex', '0');
    newPanel.classList.add('show', 'active');

    if (focusTab) {
        newTab.focus();
    }
}

function getFocusableElementsInTab(container) {
    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        'area[href]',
        'iframe',
        'object',
        'embed'
    ].join(', ');

    return Array.from(container.querySelectorAll(focusableSelectors))
        .filter(function(element) {
            const style = window.getComputedStyle(element);
            return style.display !== 'none' && 
                   style.visibility !== 'hidden' && 
                   !element.hasAttribute('aria-hidden');
        });
}

jq(document).ready(function () {
    initTabNavigation();
});
